import { render, staticRenderFns } from "./RefundList2.vue?vue&type=template&id=06ec9503&scoped=true&"
import script from "./RefundList2.vue?vue&type=script&lang=js&"
export * from "./RefundList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ec9503",
  null
  
)

export default component.exports